export default __webpack_public_path__ + "static/media/classification.fa0a5c4f.png";